<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VersusSlice} from '@prismicio-types';
    import VersusDefault from './variations/VersusDefault.vue';
    import VersusSide from './variations/VersusSide.vue';

    const props = defineProps(getSliceComponentProps<VersusSlice>(['slice', 'index', 'slices', 'context']));

    const variationComponents = {
        default: VersusDefault,
        versusSide: VersusSide,
    };
</script>
